module.exports = __webpack_public_path__ + "img/icon_2.e635dd17.svg";